// extracted by mini-css-extract-plugin
export default {"hero-module-wrapper":"mAZF70It--VerticalHero_hero-module-wrapper__VdgvR","heroModuleWrapper":"mAZF70It--VerticalHero_hero-module-wrapper__VdgvR"};